import React from "react";
import DiscHero from "../components/discHero";
import GeneralInformation from "../components/GeneralInformation";
import DocumentsAndAcademics from "../components/DocumentsAndAcademics";
import StaffAndResults from "../components/StaffAndResults";
import SchoolInfrastructure from "../components/SchoolInfrastructure";
import PrincipalMessage from "../components/PrincipalMessage";

const Disclosure = () => {
  return (
    <div className="career-page">
      <DiscHero />
      <GeneralInformation />
      <DocumentsAndAcademics />
      <StaffAndResults />
      <SchoolInfrastructure />
      <PrincipalMessage />
      {}
    </div>
  );
};

export default Disclosure;
